export default __webpack_public_path__ + "static/media/results.46b4a7fc.mp4";